import React from "react";
import { TraceEvaluation } from "../types";
import { EvaluationCard } from "./EvaluationCard";

interface AutomatedEvaluationsProps {
  evaluations: TraceEvaluation[];
  copiedExplanationId: string | null;
  copiedSourceId: string | null;
  onCopyExplanation: (id: string) => void;
  onCopySource: (id: string) => void;
  onViewSubTrace: (data: Record<string, any>, evaluatorName: string | null) => void;
  onSourceClick: (type: string, id: string) => void;
}

export function AutomatedEvaluations({
  evaluations,
  copiedExplanationId,
  copiedSourceId,
  onCopyExplanation,
  onCopySource,
  onViewSubTrace,
  onSourceClick,
}: AutomatedEvaluationsProps) {
  if (evaluations.length === 0) return null;

  return (
    <div>
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-xs font-semibold text-muted-foreground uppercase tracking-wider">
          Automated Evaluations
        </h3>
        <span className="text-xs font-medium text-muted-foreground bg-muted px-2 py-0.5 rounded">
          {evaluations.length} Run
        </span>
      </div>
      <div className="space-y-3">
        {evaluations.map((ev) => (
          <EvaluationCard
            key={ev.id}
            evaluation={ev}
            copiedExplanationId={copiedExplanationId}
            copiedSourceId={copiedSourceId}
            onCopyExplanation={onCopyExplanation}
            onCopySource={onCopySource}
            onViewSubTrace={onViewSubTrace}
            onSourceClick={onSourceClick}
          />
        ))}
      </div>
    </div>
  );
}
